import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface PreviewData {
  thumbnail: string;
  fileName: string;
}

@Component({
  selector: 'et-atoms-doc-preview',
  templateUrl: './document-preview.component.html',
  styleUrls: ['./document-preview.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class DocumentPreviewComponent {
  data = inject<PreviewData>(MAT_DIALOG_DATA);
}
